"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useOutsideClick = exports.getOutsideClickHandler = void 0;

var _react = require("react");

var getOutsideClickHandler = function getOutsideClickHandler(reactElRef, callback) {
  return function (event) {
    var snackbarElement = reactElRef.current;
    var targetElement = event.target;

    do {
      if (targetElement === snackbarElement) {
        return;
      }

      targetElement = targetElement.parentNode;
    } while (targetElement);

    callback(event);
  };
};

exports.getOutsideClickHandler = getOutsideClickHandler;

var useOutsideClick = function useOutsideClick(handler, active) {
  (0, _react.useEffect)(function () {
    if (!active) return; // whithout setTimeout could be this bug (only if react v17):
    // if in outside component setActive(true) trigger by click
    // here active flag becoming true and it adding event listener on document
    // click event are propogating and handler executing
    // it could lead to immediate close

    setTimeout(function () {
      return document.addEventListener('click', handler);
    }, 0);
    return function () {
      return document.removeEventListener('click', handler);
    };
  }, [handler, active]);
};

exports.useOutsideClick = useOutsideClick;